export enum TSRefreshEvent {
    REFRESH_ST_TABLE = <any> 'refreshDvStTable',
}



// WEBPACK FOOTER //
// ./src/app/core/events/TSRefreshEvent.ts